import React, { FunctionComponent } from 'react'
import { DivProps } from '@commonTypes'

interface FlexProps {
  wrap?: 'inherit' | 'initial' | 'nowrap' | 'unset' | 'wrap' | 'wrap-reverse'
  align?: 'baseline' | 'center' | 'flex-start' | 'flex-end' | 'stretch'
  shrink?: number
  justify?:
    | 'baseline'
    | 'center'
    | 'flex-start'
    | 'flex-end'
    | 'stretch'
    | 'space-arround'
    | 'space-between'
  direction?: 'row' | 'column'
  'data-item'?: string
  children: any
}

const Flex: FunctionComponent<React.PropsWithChildren<DivProps & FlexProps>> = ({
  wrap,
  align,
  justify,
  direction,
  shrink,
  style,
  ...props
}) => {
  return (
    <div
      data-item={props['data-item']}
      style={{
        display: 'flex',
        flexWrap: wrap,
        alignItems: align,
        justifyContent: justify,
        flexDirection: direction,
        flexShrink: shrink,
        ...style,
      }}
      {...props}
    />
  )
}

export default Flex
